export const historyData = [
    {
        year: "2020",
        yearData: [
            {
                content: "NETFLX Produces Opening Title of Domestic Drama",
                motion: "MOTION"
            },
            {
                content: "Cheil Worldwide / Innocean Partner Selection",
                motion: "MOTION"
            },
            {
                content: "Hyndai Card TVC and Viral Imaging",
                motion: "MOTION"
            },
            {
                content: "Samsung Grande Dryer AI Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "Samsung Card Collaboration Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "JTBC Value-Mental-Posture Spot Video Production",
                motion: "MOTION"
            },
            {
                content: "SKT Quantum + Galaxy A TVC and Digital Imaging",
                motion: "MOTION"
            },
            {
                content: "Hyundai Oilbank, a symbol, animation production",
                motion: "MOTION"
            },
        ]
    },
    {
        year: "2019",
        yearData: [
            {
                content: "NETFLX Produces Opening Title of Domestic Drama",
                motion: "MOTION"
            },
            {
                content: "Cheil Worldwide / Innocean Partner Selection",
                motion: "MOTION"
            },
            {
                content: "Hyndai Card TVC and Viral Imaging",
                motion: "MOTION"
            },
            {
                content: "Samsung Grande Dryer AI Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "Samsung Card Collaboration Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "JTBC Value-Mental-Posture Spot Video Production",
                motion: "MOTION"
            },
            {
                content: "SKT Quantum + Galaxy A TVC and Digital Imaging",
                motion: "MOTION"
            },
            {
                content: "Hyundai Oilbank, a symbol, animation production",
                motion: "MOTION"
            },
        ]
    },
    {
        year: "2018",
        yearData: [
            {
                content: "NETFLX Produces Opening Title of Domestic Drama",
                motion: "MOTION"
            },
            {
                content: "Cheil Worldwide / Innocean Partner Selection",
                motion: "MOTION"
            },
            {
                content: "Hyndai Card TVC and Viral Imaging",
                motion: "MOTION"
            },
            {
                content: "Samsung Grande Dryer AI Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "Samsung Card Collaboration Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "JTBC Value-Mental-Posture Spot Video Production",
                motion: "MOTION"
            },
            {
                content: "SKT Quantum + Galaxy A TVC and Digital Imaging",
                motion: "MOTION"
            },
            {
                content: "Hyundai Oilbank, a symbol, animation production",
                motion: "MOTION"
            },
        ]
    }
    , {
        year: "2017",
        yearData: [
            {
                content: "NETFLX Produces Opening Title of Domestic Drama",
                motion: "MOTION"
            },
            {
                content: "Cheil Worldwide / Innocean Partner Selection",
                motion: "MOTION"
            },
            {
                content: "Hyndai Card TVC and Viral Imaging",
                motion: "MOTION"
            },
            {
                content: "Samsung Grande Dryer AI Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "Samsung Card Collaboration Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "JTBC Value-Mental-Posture Spot Video Production",
                motion: "MOTION"
            },
            {
                content: "SKT Quantum + Galaxy A TVC and Digital Imaging",
                motion: "MOTION"
            },
            {
                content: "Hyundai Oilbank, a symbol, animation production",
                motion: "MOTION"
            },
        ]
    }
    , {
        year: "2016",
        yearData: [
            {
                content: "NETFLX Produces Opening Title of Domestic Drama",
                motion: "MOTION"
            },
            {
                content: "Cheil Worldwide / Innocean Partner Selection",
                motion: "MOTION"
            },
            {
                content: "Hyndai Card TVC and Viral Imaging",
                motion: "MOTION"
            },
            {
                content: "Samsung Grande Dryer AI Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "Samsung Card Collaboration Digital Video Production",
                motion: "MOTION"
            },
            {
                content: "JTBC Value-Mental-Posture Spot Video Production",
                motion: "MOTION"
            },
            {
                content: "SKT Quantum + Galaxy A TVC and Digital Imaging",
                motion: "MOTION"
            },
            {
                content: "Hyundai Oilbank, a symbol, animation production",
                motion: "MOTION"
            },
        ]
    }
]